const swiperRev = new Swiper(".swiper-rev", {
  loop: true,
  slidesPerView: "auto",
  slidesPerGroup: 1,
  spaceBetween: 30,
  centeredSlides: true,

  breakpoints: {
    768: {
      slidesPerView: 3,
      slidesPerGroup: 1,
      spaceBetween: 40,
    },
  },
  pagination: {
    el: ".rev-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".rev-next",
    prevEl: ".rev-prev",
  },
});
